import React from "react";

const h = React.createElement;

const competitors = [
  { rank: 5, city: "ירושלים", score: "3,120", color: "#b941ff", pale: "#ebb7ff", height: 335 },
  { rank: 2, city: "תל אביב", score: "9,230", color: "#1da7ff", pale: "#bdeaff", height: 415 },
  { rank: 1, city: "בני ברק", score: "12,450", color: "#ffb900", pale: "#fff2b0", height: 475, winner: true },
  { rank: 3, city: "ראש העין", score: "6,890", color: "#ff6b3a", pale: "#ffd1b8", height: 415 },
  { rank: 4, city: "חיפה", score: "4,560", color: "#9144ff", pale: "#e2c4ff", height: 345 },
];

function ActionIcon({ name }) {
  if (name === "play") {
    return h(
      "svg",
      { viewBox: "0 0 24 24", "aria-hidden": true },
      h("path", { d: "M7 4.5v15l12-7.5z", fill: "currentColor" })
    );
  }

  if (name === "players") {
    return h(
      "svg",
      { viewBox: "0 0 24 24", "aria-hidden": true },
      h("circle", { cx: "9", cy: "7.5", r: "4", fill: "currentColor" }),
      h("path", { d: "M2 20c0-4.4 2.7-7 7-7s7 2.6 7 7z", fill: "currentColor" }),
      h("circle", { cx: "17.6", cy: "8.2", r: "3", fill: "currentColor", opacity: ".75" }),
      h("path", {
        d: "M15.5 14c4.3-.2 6.5 2.1 6.5 6h-4.3c0-2.4-.7-4.3-2.2-5.8z",
        fill: "currentColor",
        opacity: ".75",
      })
    );
  }

  return h(
    "svg",
    { viewBox: "0 0 24 24", "aria-hidden": true },
    h("path", {
      d: "M19.8 10a8 8 0 1 1-2.4-4.7M20 4v6h-6",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    })
  );
}

function Podium({ competitor }) {
  const bars = Array.from({ length: 25 }, (_, index) =>
    h("i", {
      key: index,
      style: {
        height: `${18 + ((index * 31) % 93)}px`,
        animationDelay: `${-(index % 8) * 0.23}s`,
      },
    })
  );

  return h(
    "article",
    {
      className: `podium${competitor.winner ? " podium--winner" : ""}`,
      style: {
        "--glow": competitor.color,
        "--pale": competitor.pale,
        "--podium-height": `${competitor.height}px`,
      },
      "aria-label": `מקום ${competitor.rank}, ${competitor.city}, ${competitor.score} נקודות`,
    },
    h("div", { className: "medal" }, h("span", null, competitor.rank)),
    h("div", { className: "glass-facets" }),
    h(
      "div",
      { className: "details" },
      h("h2", null, competitor.city),
      h("div", { className: "light-line" }),
      h("strong", null, competitor.score),
      h("p", null, "נקודות")
    ),
    h("div", { className: "light-bars", "aria-hidden": true }, ...bars),
    h("div", { className: "base" }, h("i"), h("i"), h("i"))
  );
}

export default function Ihgfugh() {
  return h(
    "main",
    { className: "screen", dir: "rtl" },
    h("style", null, `
        :root {
          font-family: Arial, "Heebo", sans-serif;
          color: white;
          background: #01040d;
          font-synthesis: none;
        }

        * { box-sizing: border-box; }
        html, body, #root { width: 100%; min-width: 320px; min-height: 100%; margin: 0; }
        body { overflow-x: hidden; }
        button { font: inherit; }

        .screen {
          position: relative;
          isolation: isolate;
          min-height: 100vh;
          overflow: hidden;
          padding: 28px 24px 30px;
          background:
            radial-gradient(ellipse at 50% 91%, rgba(255, 181, 0, .22), transparent 18%),
            radial-gradient(ellipse at 29% 89%, rgba(0, 157, 255, .18), transparent 16%),
            radial-gradient(ellipse at 72% 89%, rgba(255, 83, 39, .16), transparent 16%),
            radial-gradient(ellipse at 11% 88%, rgba(157, 48, 255, .15), transparent 14%),
            radial-gradient(ellipse at 89% 88%, rgba(126, 45, 255, .15), transparent 14%),
            radial-gradient(circle at 50% 32%, rgba(0, 63, 122, .23), transparent 34%),
            radial-gradient(circle at 14% 67%, rgba(51, 16, 130, .25), transparent 31%),
            radial-gradient(circle at 88% 65%, rgba(58, 13, 117, .21), transparent 28%),
            linear-gradient(180deg, #01030a 0%, #020817 58%, #01040d 100%);
        }

        .screen::before {
          content: "";
          position: absolute;
          z-index: -2;
          inset: 145px 0 100px;
          opacity: .7;
          background-image:
            radial-gradient(circle, #ffad22 0 1.2px, transparent 2.8px),
            radial-gradient(circle, #8b43ff 0 1px, transparent 2.6px),
            radial-gradient(circle, #2788ff 0 1px, transparent 2.5px);
          background-position: 8px 2px, 54px 23px, 101px 68px;
          background-size: 119px 101px, 157px 139px, 187px 153px;
          -webkit-mask-image: linear-gradient(to bottom, transparent, #000 18%, #000 88%, transparent);
          mask-image: linear-gradient(to bottom, transparent, #000 18%, #000 88%, transparent);
          animation: stars 11s linear infinite;
        }

        .screen::after {
          content: "";
          position: absolute;
          z-index: -1;
          right: 3%;
          bottom: 72px;
          left: 3%;
          height: 155px;
          border-radius: 50%;
          background:
            radial-gradient(ellipse, rgba(36, 105, 255, .18), transparent 60%),
            repeating-radial-gradient(ellipse, transparent 0 26px, rgba(106, 59, 255, .34) 27px 28px, transparent 29px 49px);
          filter: drop-shadow(0 0 14px rgba(96, 49, 255, .44));
          transform: perspective(490px) rotateX(64deg);
        }

        @keyframes stars {
          to { background-position: 127px -99px, -103px -116px, 288px -85px; }
        }

        .heading {
          position: relative;
          z-index: 5;
          text-align: center;
        }

        .trophy {
          display: block;
          font-size: clamp(45px, 4vw, 64px);
          line-height: 1;
          filter: drop-shadow(0 0 11px rgba(255, 185, 0, .55));
        }

        .heading h1 {
          margin: 9px 0 0;
          color: #f5f6f8;
          font-size: clamp(44px, 5.15vw, 78px);
          font-weight: 900;
          line-height: 1.05;
          letter-spacing: 8px;
          text-shadow: 0 3px 0 #a7afb9, 0 8px 24px #000;
        }

        .subtitle {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          margin-top: 18px;
          color: #ffc426;
          font-size: clamp(22px, 2.25vw, 34px);
          font-weight: 800;
          letter-spacing: 4.5px;
        }

        .subtitle::before, .subtitle::after {
          content: "";
          width: clamp(82px, 10vw, 145px);
          height: 2px;
          background: linear-gradient(90deg, transparent, #ffc400);
          box-shadow: 0 0 6px #f6a900;
        }

        .subtitle::after { transform: scaleX(-1); }

        .podiums {
          direction: ltr;
          position: relative;
          z-index: 2;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          gap: clamp(20px, 3.65vw, 56px);
          width: min(1420px, 96vw);
          min-height: 610px;
          margin: -1px auto 0;
          padding: 65px 0 43px;
        }

        .podium {
          direction: rtl;
          position: relative;
          isolation: isolate;
          width: clamp(150px, 14vw, 214px);
          height: calc(var(--podium-height) - 35px);
          flex: 0 0 clamp(150px, 14vw, 214px);
          border: 2px solid var(--glow);
          border-bottom: 0;
          border-radius: 30px 30px 20px 20px;
          background:
            linear-gradient(132deg, color-mix(in srgb, var(--glow) 23%, transparent), transparent 34%),
            linear-gradient(225deg, rgba(255,255,255,.11), transparent 32%),
            linear-gradient(180deg, rgba(8,21,41,.67), rgba(1,5,14,.48));
          -webkit-backdrop-filter: blur(7px) saturate(140%);
          backdrop-filter: blur(7px) saturate(140%);
          box-shadow:
            inset 0 0 0 3px rgba(255,255,255,.14),
            inset 9px 0 18px color-mix(in srgb, var(--glow) 15%, transparent),
            inset -8px 0 18px rgba(255,255,255,.05),
            inset 0 0 47px color-mix(in srgb, var(--glow) 17%, transparent),
            0 0 7px white,
            0 0 17px var(--glow),
            0 0 39px color-mix(in srgb, var(--glow) 68%, transparent);
        }

        .podium:first-child,
        .podium:last-child {
          width: clamp(140px, 12.2vw, 186px);
          flex-basis: clamp(140px, 12.2vw, 186px);
        }

        .podium--winner {
          z-index: 5;
          width: clamp(192px, 16.7vw, 256px);
          flex-basis: clamp(192px, 16.7vw, 256px);
          border-width: 3px;
          border-bottom-width: 0;
          box-shadow:
            inset 0 0 0 3px rgba(255,255,255,.16),
            inset 10px 0 22px rgba(255,184,0,.12),
            inset 0 0 64px rgba(255,184,0,.16),
            0 0 8px #fff2a4,
            0 0 21px var(--glow),
            0 0 52px rgba(255,174,0,.5);
        }

        .glass-facets {
          position: absolute;
          inset: 0;
          overflow: hidden;
          border-radius: inherit;
          opacity: .69;
          background:
            linear-gradient(132deg, transparent 14%, rgba(255,255,255,.28) 14.5% 15%, transparent 15.5% 35%, rgba(255,255,255,.13) 35.5% 36%, transparent 36.5%),
            linear-gradient(48deg, transparent 27%, color-mix(in srgb, var(--glow) 21%, transparent) 27.5% 39%, transparent 39.5%),
            conic-gradient(from 36deg at 31% 14%, transparent, color-mix(in srgb, var(--glow) 37%, transparent), transparent 31%),
            conic-gradient(from 210deg at 78% 14%, transparent, rgba(255,255,255,.22), transparent 30%);
          clip-path: polygon(0 0,100% 0,100% 58%,87% 46%,70% 52%,53% 36%,34% 49%,17% 34%,0 54%);
        }

        .podium::before {
          content: "";
          position: absolute;
          z-index: 2;
          inset: 8px 8px 4px;
          pointer-events: none;
          border-top: 1px solid rgba(255,255,255,.4);
          border-right: 1px solid rgba(255,255,255,.09);
          border-left: 1px solid rgba(255,255,255,.25);
          border-radius: 22px 22px 13px 13px;
          background:
            linear-gradient(105deg, transparent 8%, rgba(255,255,255,.055) 15%, transparent 22%),
            linear-gradient(74deg, transparent 67%, color-mix(in srgb, var(--glow) 8%, transparent) 75%, transparent 84%);
          box-shadow: inset 0 15px 22px rgba(255,255,255,.025);
        }

        .podium::after {
          display: none;
        }

        .medal {
          position: absolute;
          z-index: 6;
          top: -62px;
          left: 50%;
          display: grid;
          width: 101px;
          height: 101px;
          place-items: center;
          border: 2px solid color-mix(in srgb, var(--glow) 82%, var(--pale));
          outline: 3px solid color-mix(in srgb, var(--glow) 72%, #080d18);
          outline-offset: 1px;
          border-radius: 50%;
          color: var(--pale);
          background:
            radial-gradient(
              circle at 35% 28%,
              var(--pale) 0%,
              var(--glow) 27%,
              color-mix(in srgb, var(--glow) 46%, #030814) 57%,
              #030712 79%
            );
          box-shadow:
            inset 0 0 0 3px rgba(255,255,255,.3),
            inset 0 0 0 7px color-mix(in srgb, var(--glow) 72%, #08101c),
            inset 0 0 20px #000,
            0 3px 0 #08101b,
            0 0 0 2px #050a13,
            0 0 5px var(--glow),
            0 0 17px var(--glow);
          transform: translateX(-50%);
        }

        .podium--winner .medal {
          top: -69px;
          width: 116px;
          height: 116px;
        }

        .medal::after {
          content: "";
          position: absolute;
          inset: 6px;
          z-index: 1;
          border: 1px solid color-mix(in srgb, var(--glow) 74%, var(--pale));
          border-radius: 50%;
          box-shadow:
            inset 0 0 8px rgba(255,255,255,.18),
            0 0 5px color-mix(in srgb, var(--glow) 65%, transparent);
        }

        .medal::before {
          content: "";
          position: absolute;
          z-index: 1;
          top: 9px;
          right: 17px;
          left: 17px;
          height: 32%;
          border-radius: 50%;
          background: linear-gradient(180deg, rgba(255,255,255,.68), rgba(255,255,255,.05));
          opacity: .55;
          transform: rotate(-7deg);
        }

        .medal span {
          position: relative;
          z-index: 2;
          font-size: 57px;
          font-weight: 900;
          line-height: 1;
          text-shadow: 0 4px 2px rgba(0,0,0,.75);
        }

        .podium--winner .medal span { font-size: 64px; }

        .details {
          position: relative;
          z-index: 3;
          margin-top: 43%;
          padding: 0 18px;
          text-align: center;
        }

        .podium:nth-child(2) .details,
        .podium:nth-child(4) .details {
          margin-top: 49.5%;
        }

        .podium--winner .details { margin-top: 52%; }

        .podium:first-child .details,
        .podium:last-child .details {
          margin-top: 46%;
        }

        .details h2 {
          margin: 0;
          color: var(--pale);
          font-size: clamp(22px, 2vw, 33px);
          font-weight: 800;
          white-space: nowrap;
        }

        .light-line {
          width: 78%;
          height: 1px;
          margin: 24px auto;
          background: linear-gradient(90deg, transparent, var(--glow), white, var(--glow), transparent);
          box-shadow: 0 0 8px var(--glow);
        }

        .details strong {
          display: block;
          color: var(--pale);
          font-size: clamp(25px, 2.15vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          letter-spacing: 1px;
        }

        .podium:first-child .light-line,
        .podium:last-child .light-line {
          margin-block: 18px;
        }

        .podium:first-child .details strong,
        .podium:last-child .details strong {
          font-size: 30px;
        }

        .details p {
          margin: 8px 0 0;
          color: var(--glow);
          font-size: clamp(17px, 1.45vw, 23px);
          font-weight: 700;
        }

        .podium--winner .details h2,
        .podium--winner .details strong { color: #fffbed; }

        .podium--winner .details strong { font-size: clamp(31px, 2.6vw, 40px); }

        .podium--winner .light-line { margin-block: 30px; }

        .light-bars {
          position: absolute;
          right: 8px;
          bottom: 4px;
          left: 8px;
          display: flex;
          height: 135px;
          align-items: flex-end;
          justify-content: space-around;
          overflow: hidden;
          opacity: .92;
          -webkit-mask-image: linear-gradient(to bottom, transparent, #000 36%);
          mask-image: linear-gradient(to bottom, transparent, #000 36%);
        }

        .light-bars i {
          display: block;
          width: 1px;
          max-height: 112px;
          background: linear-gradient(to top, #fff, var(--glow) 55%, transparent);
          box-shadow: 0 0 5px var(--glow);
          transform-origin: bottom;
          animation: bars 2.6s ease-in-out infinite alternate;
        }

        @keyframes bars { to { transform: scaleY(.45); opacity: .35; } }

        .base {
          position: absolute;
          z-index: -1;
          right: -18px;
          bottom: -52px;
          left: -18px;
          height: 52px;
          overflow: visible;
          border: 2px solid color-mix(in srgb, var(--glow) 76%, #10131a);
          border-radius: 50% / 23%;
          background:
            linear-gradient(
              90deg,
              rgba(0,0,0,.72) 0%,
              rgba(0,0,0,.2) 18%,
              rgba(255,255,255,.12) 48%,
              rgba(0,0,0,.18) 72%,
              rgba(0,0,0,.76) 100%
            ),
            linear-gradient(
              180deg,
              color-mix(in srgb, var(--glow) 88%, var(--pale)) 0%,
              var(--glow) 14%,
              color-mix(in srgb, var(--glow) 76%, #080b12) 35%,
              color-mix(in srgb, var(--glow) 61%, #03060c) 70%,
              color-mix(in srgb, var(--glow) 42%, #010309) 100%
            );
          box-shadow:
            inset 0 5px 4px rgba(255,255,255,.22),
            inset 0 -8px 12px rgba(0,0,0,.72),
            0 5px 0 color-mix(in srgb, var(--glow) 35%, #010207),
            0 10px 12px #000,
            0 0 17px color-mix(in srgb, var(--glow) 65%, transparent),
            0 24px 32px color-mix(in srgb, var(--glow) 28%, transparent);
          transform: translateY(-5px);
        }

        .base::before, .base::after, .base i {
          content: "";
          position: absolute;
          display: block;
          left: 50%;
          pointer-events: none;
          border-radius: 50% / 38%;
          transform: translateX(-50%);
        }

        .base::before {
          z-index: 3;
          top: -2px;
          display: block;
          width: calc(100% - 4px);
          height: 38%;
          border: 3px solid color-mix(in srgb, var(--glow) 58%, var(--pale));
          background: radial-gradient(
            ellipse at 50% 42%,
            color-mix(in srgb, var(--glow) 58%, #171b25) 0%,
            color-mix(in srgb, var(--glow) 45%, #070a11) 64%,
            color-mix(in srgb, var(--glow) 32%, #010207) 100%
          );
          box-shadow:
            inset 0 3px 4px rgba(255,255,255,.22),
            inset 0 -5px 8px rgba(0,0,0,.52),
            0 0 6px color-mix(in srgb, var(--glow) 62%, transparent);
        }

        .base i:first-child {
          z-index: 5;
          top: -11px;
          width: 88%;
          height: 36%;
          border-width: 3px;
          border-style: solid;
          border-color: color-mix(in srgb, var(--glow) 60%, var(--pale));
          background: radial-gradient(
            ellipse at 50% 45%,
            color-mix(in srgb, var(--glow) 70%, var(--pale)) 0%,
            color-mix(in srgb, var(--glow) 62%, #11151d) 55%,
            color-mix(in srgb, var(--glow) 48%, #03050b) 100%
          );
          box-shadow:
            inset 0 4px 5px rgba(255,255,255,.24),
            inset 0 -7px 10px rgba(0,0,0,.46),
            0 1px 0 color-mix(in srgb, var(--pale) 75%, var(--glow)),
            0 0 7px color-mix(in srgb, var(--glow) 72%, transparent);
        }

        .base::after,
        .base i:nth-child(2),
        .base i:nth-child(3) {
          display: none;
        }

        .podium--winner .base {
          right: -25px;
          bottom: -80px;
          left: -25px;
          height: 80px;
        }

        .podium:nth-child(2) .base,
        .podium:nth-child(4) .base {
          right: -21px;
          bottom: -64px;
          left: -21px;
          height: 64px;
        }

        @media (min-width: 1001px) {
          .podium--winner {
            transform: translateY(10px) scale(1.04);
            transform-origin: bottom center;
          }

          .podium:nth-child(2),
          .podium:nth-child(4) {
            z-index: 2;
            transform: scale(.97);
            transform-origin: bottom center;
          }

          .podium:first-child,
          .podium:last-child {
            z-index: 1;
            transform: translateY(-3px) scale(.94);
            transform-origin: bottom center;
          }
        }

        .actions {
          direction: ltr;
          position: relative;
          z-index: 10;
          display: flex;
          justify-content: center;
          gap: 24px;
          margin: 82px auto 0;
        }

        .action {
          direction: rtl;
          display: flex;
          width: min(240px, 29vw);
          height: 67px;
          align-items: center;
          justify-content: center;
          gap: 13px;
          border: 1px solid #7282ab;
          border-radius: 999px;
          color: #f4f6fb;
          background: linear-gradient(180deg, rgba(12,25,52,.86), rgba(3,8,21,.94));
          box-shadow: inset 0 0 17px rgba(27,56,110,.25), 0 5px 20px rgba(0,0,0,.35);
          font-size: clamp(16px, 1.5vw, 21px);
          font-weight: 700;
          cursor: pointer;
          transition: .2s ease;
        }

        .action:hover {
          border-color: #c0d2ff;
          box-shadow: 0 0 19px rgba(64,112,255,.3);
          transform: translateY(-2px);
        }

        .action svg { width: 25px; height: 25px; color: #e8efff; }
        .action--players svg { color: #6742ff; filter: drop-shadow(0 0 5px #4828ff); }

        @media (max-width: 1000px) {
          .podiums { gap: 10px; width: 100%; }
          .podium { min-width: 135px; }
          .medal { top: -49px; width: 82px; height: 82px; }
          .podium--winner .medal { top: -57px; width: 96px; height: 96px; }
          .medal span, .podium--winner .medal span { font-size: 47px; }
        }

        @media (max-width: 760px) {
          .screen { padding-inline: 10px; }
          .heading h1 { letter-spacing: 3px; }
          .podiums {
            justify-content: flex-start;
            width: max-content;
            min-width: 100%;
            margin-top: 4px;
            padding-inline: 24px;
            transform: scale(.71);
            transform-origin: bottom left;
          }
          .podium,
          .podium:first-child,
          .podium:last-child {
            width: 174px;
            min-width: 174px;
            flex-basis: 174px;
          }
          .podium--winner {
            width: 208px;
            min-width: 208px;
            flex-basis: 208px;
          }
          .actions { gap: 7px; margin-top: -88px; }
          .action { width: 31.5vw; height: 56px; gap: 6px; padding: 0 7px; font-size: 13px; }
          .action svg { width: 18px; height: 18px; }
        }

        @media (max-width: 480px) {
          .screen { padding-top: 19px; }
          .trophy { font-size: 39px; }
          .heading h1 { font-size: 34px; }
          .subtitle { gap: 10px; font-size: 20px; }
          .subtitle::before, .subtitle::after { width: 56px; }
        }

        @media (prefers-reduced-motion: reduce) {
          *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; }
        }
      `),
    h(
      "header",
      { className: "heading" },
      h("span", { className: "trophy", role: "img", "aria-label": "גביע" }, "🏆"),
      h("h1", null, "דירוג הקבוצות"),
      h("div", { className: "subtitle" }, "קליקרים")
    ),
    h(
      "section",
      { className: "podiums", "aria-label": "דירוג הקבוצות" },
      ...competitors.map((competitor) =>
        h(Podium, { key: competitor.rank, competitor })
      )
    ),
    h(
      "nav",
      { className: "actions", "aria-label": "פעולות" },
      h(
        "button",
        { className: "action", type: "button" },
        h(ActionIcon, { name: "play" }),
        h("span", null, "המשך משחק")
      ),
      h(
        "button",
        { className: "action action--players", type: "button" },
        h(ActionIcon, { name: "players" }),
        h("span", null, "חזרה לשחקנים")
      ),
      h(
        "button",
        { className: "action", type: "button" },
        h(ActionIcon, { name: "refresh" }),
        h("span", null, "חזור שוב")
      )
    )
  );
}
